import { cn } from '@/utils/cn';
import type { RolePermissionDetail } from '../types/rolesDetail.types';

interface RolePermissionsBlockProps {
  permissions: RolePermissionDetail[];
  isLoading?: boolean;
}

export function RolePermissionsBlock({ permissions, isLoading }: RolePermissionsBlockProps) {
  if (isLoading) return <div className="h-64 animate-pulse rounded-md border border-slate-100 bg-white p-3" />;

  const grouped = permissions.reduce<Record<string, RolePermissionDetail[]>>((acc, permission) => {
    const key = `${permission.moduleName} / ${permission.resourceName}`;
    acc[key] = [...(acc[key] || []), permission];
    return acc;
  }, {});

  return (
    <section className="rounded-md border border-slate-100 bg-white p-3 shadow-sm">
      <div className="space-y-2 text-sm">
        <h2 className="font-medium text-slate-900">Danh sách quyền</h2>
        {permissions.length ? (
          <div className="space-y-3">
            {Object.entries(grouped).map(([groupName, items]) => (
              <div key={groupName} className="rounded-md border border-slate-100 p-3">
                <div className="space-y-2 text-sm">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-medium text-slate-800">{groupName}</h3>
                    <span className="rounded-md bg-slate-100 px-2 py-1 text-sm text-slate-600">{items.length} quyền</span>
                  </div>
                  <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-3">
                    {items.map((permission) => (
                      <div key={permission.key} className="rounded-md bg-slate-50 p-3">
                        <div className="space-y-2 text-sm">
                          <div className="flex items-center justify-between gap-2">
                            <p className="font-semibold text-slate-900">{permission.actionName}</p>
                            <span className={cn('rounded-md px-2 py-1 text-sm', permission.risk === 'Cao' || permission.risk === 'Rất cao' ? 'bg-rose-50 text-rose-700' : 'bg-slate-100 text-slate-600')}>
                              {permission.risk}
                            </span>
                          </div>
                          <p className="text-slate-500">{permission.description}</p>
                          <p className="text-slate-400">Phạm vi: {permission.scopes.join(', ')}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="rounded-md bg-slate-50 p-3 text-center text-sm text-slate-500">Vai trò này chưa được gán quyền.</div>
        )}
      </div>
    </section>
  );
}
